export default "__VITE_ASSET__CrqndWkj__"